import { useEffect, useState } from 'react';

import { changeAccountLeverage } from 'actions/account';
import { userSelector } from 'selectors/otherSelectors';
import {
  productDefaultLeverageSelector,
  selectedProductSelector,
} from 'selectors/tradeSelectors';
import { useAppDispatch, useAppSelector } from 'storeHooks';

export function useDefaultLeverage(leverage: number | null) {
  const dispatch = useAppDispatch();
  const { id: userId } = useAppSelector(userSelector);
  const selectedProduct = useAppSelector(selectedProductSelector);
  const defaultLeverage = useAppSelector(productDefaultLeverageSelector);
  const [markAsDefault, setMarkAsDefault] = useState(
    !!defaultLeverage && Number(defaultLeverage) === leverage
  );

  const handleChangeAccountLeverage = async () => {
    if (!userId || !selectedProduct?.spot_index?.config.underlying_asset) {
      return;
    }
    await dispatch(
      changeAccountLeverage({
        user_id: userId,
        account_leverage: String(leverage),
        options_underlying_symbol: selectedProduct.spot_index.config.underlying_asset,
      })
    );
  };

  useEffect(() => {
    setMarkAsDefault(!!defaultLeverage && Number(defaultLeverage) === leverage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leverage]);

  return {
    markAsDefault,
    defaultLeverage,
    changeMarkAsDefault: setMarkAsDefault,
    handleChangeAccountLeverage,
  };
}
